// Modules
import React from 'react';

// Icons
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const NoData = ({ stratification }) => (
    <div className="no-data-container">
        <ReportProblemIcon className="no-data-icon" />
        <p>
            Due to some recently identified errors in some of the age-adjusted
            and age-stratified metrics for <b>COPD</b>, <b>Heart Attack</b>,{' '}
            <b>Falls</b>, and <b>TBI</b>, we have temporarily removed those
            pages. We are working to restore data as soon as possible. Thank you
            for your patience.
        </p>
        {stratification && (
            <button
                type="button"
                onClick={() => window.location.reload()}
                className="no-data-button"
            >
                <KeyboardBackspaceIcon className="no-data-button-icon" />
                Go Back
            </button>
        )}
    </div>
);

export default NoData;
